import React, { useEffect, useState } from 'react';
import { CardHeader } from '@mui/material';
import { StyledCellLink, Percentage, Weight } from '../Common/DataGrid/CellComponents';
import { getDateRangeFilterOperator, getRangeFilterOperator } from '../Common/DataGrid/FilterComponents';
import { select_commonCellProps, text_commonCellProps } from '../Common/DataGrid/utils';
import {
    DataGrid,
    PageTitleWithToolTip
} from '../Common';
import Routes from '../../routes';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { fetchFilterValues } from '../../utils';

const dateRangeFilterOperator = getDateRangeFilterOperator({});
const rangeFilterOperator = getRangeFilterOperator({});

const columns = [
    {
        field: 'regionName',
        headerName: 'Region',
        ...text_commonCellProps
    },
    {
        field: 'assetName',
        headerName: 'Asset Name',
        ...text_commonCellProps,
        renderCell: ({ row: { assetName, assetId } }) => (
            <StyledCellLink
                path={`/Inventory/${assetId}`}
                text={assetName}
                from={"Compliance Center"}
                primaryLink={true}
            />
        )
    },
    {
        field: 'locationName',
        headerName: 'Location',
        ...select_commonCellProps,
        renderCell: ({ row: { locationName, locationId } }) => (
            <StyledCellLink
                path={`/Location/${locationId}`}
                text={locationName}
                from={"Compliance Center"}
                primaryLink={true}
            />
        )
    },
    {
        field: 'leakRate',
        headerName: 'Annual Leak Rate',
        filterOperators: rangeFilterOperator,
        renderCell: ({ row: { leakRate } }) => <Percentage value={leakRate} />
    },
    {
        field: 'assetType',
        headerName: 'Type',
        ...select_commonCellProps
    },
    {
        field: 'materialType',
        headerName: 'Material Type',
        ...select_commonCellProps
    },
    {
        field: 'gasCapacityLbs',
        headerName: 'Charge Size',
        valueGetter: (value) => value,
        filterOperators: rangeFilterOperator,
        renderCell: ({ row: { gasCapacityLbs } }) => <Weight value={gasCapacityLbs} />
    },
    {
        field: 'lastServiceDate',
        headerName: 'Last Service Date',
        filterOperators: dateRangeFilterOperator,
    },
]

const TopLeakRates = () => {

    const [filters, setFilters] = useState([]);

    const fetchFilters = async () => {
        const filters = await fetchFilterValues(Routes.Dashboard.TopLeakRatesDropdowns());
        setFilters(filters);
    };

    useEffect(() => { fetchFilters() }, []);

    return (
        <div top-five-leak-rate-card>
            <DataGrid
                url={Routes.Dashboard.TopLeakRates(false)}
                exportButtonURL={Routes.Dashboard.TopLeakRates(true)}
                filterOptions={filters}
                columns={columns}
                rowCount="5"
                tableId={'top-leak-rates-table'}
                exportFileName={"Top Leak Rates"}
                exportButtonAlt={"Export Top Leak Rates (.csv)"}
                noResultText="Oops...It is empty here..."
                noResultText2="Create a new asset or change your search criteria."
                headerContent={
                    <CardHeader
                        title={
                            <PageTitleWithToolTip
                                pageTitle="Top Leak Rates"
                                toolTipText="View assets with a capacity of at least 15 lbs that have a leak rate greater than 0%."
                            />
                        }
                        sx={{
                            "& .MuiCardHeader-action": { display: "flex" },
                            "& .MuiCardHeader-content": { maxWidth: "100%", textWrap: "nowrap" }
                        }}
                    />
                }
            />
        </div>
    );
}

export default TopLeakRates;
